import { useState } from 'react'
import { Clipboard, Check, FileDown } from 'lucide-react';
import TurndownService from 'turndown';
import { gfm } from 'turndown-plugin-gfm';

const turndownService = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
  bulletListMarker: '-',
});
turndownService.use(gfm);

export default function SectionActions({
  sectionTitle,
  contentRef,
  onViewMarkdown,
}) {
  const [copied, setCopied] = useState(false);

  const getMarkdown = () => {
    const node = contentRef?.current;
    if (!node) {
      console.warn('SectionActions: contentRef is not attached to a DOM node yet.');
      return '';
    }
    let tds = ''
    tds = turndownService.turndown(node.innerHTML).trim();
    tds = tds.replaceAll('Copy for LLM|View as Markdown', '').replaceAll('HttpPythonJavascript', '')
    tds = tds.replace(/```([\s\S]*?)```/g, (block, code) =>
      '```' + code.replace(/^\d+/gm, '') + '```'

    );

    return tds.trim()
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(getMarkdown());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy markdown:', err);
    }
  };

  const handleViewMarkdown = () => {
    const markdown = getMarkdown();

    if (onViewMarkdown) {
      onViewMarkdown(sectionTitle, markdown);
      return;
    }

    const blob = new Blob([markdown], { type: 'text/markdown' });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  };

  return (
    <div className="flex items-center gap-3 text-xs text-gray-400 pb-5">
      <button
        type="button"
        onClick={handleCopy}
        className="flex items-center cursor-pointer gap-1.5 hover:text-gray-900 transition-colors"
      >
        {copied ? <Check className="w-3.5 h-3.5" /> : <Clipboard className="w-3.5 h-3.5" />}
        {copied ? 'Copied!' : 'Copy for LLM'}
      </button>

      <span className="text-gray-700">|</span>

      <button
        type="button"
        onClick={handleViewMarkdown}
        className="flex items-center gap-1.5 cursor-pointer hover:text-gray-900 transition-colors"
      >
        <FileDown className="w-3.5 h-3.5" />
        View as Markdown
      </button>
    </div>
  );
}


